import {useLocaleStore} from "~/stores/LocaleStore";
import {useAlertStore} from "~/stores/AlertStore";
import {useNavigationStore} from "~/stores/NavigationStore";

export async function useClientFetch(url, opts = {}) {
    //if app received error code like 503, no need to make any queries
    const nuxtApp = useNuxtApp();
    const navigationStore = useNavigationStore();
    if (nuxtApp.payload.error) {
        if ([403,503].includes(nuxtApp.payload.error.statusCode)) {
            throw createError(nuxtApp.payload.error)
        }
    }
    if (navigationStore.outdated) {
        window.location.reload();
        return;
    }
    const locale = nuxtApp.$i18n?.locale.value;

    if (url.substring(0, 1) !== '/') {
        url = '/' + url;
    }

    let headers = {
        'Accept-Language': locale,
        'Lang': locale,
        'Environment': 'nuxt',
        'Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        'X-Currency': useLocaleStore().currency?.unit_text,
    };

    const token = await useCookie('XSRF-TOKEN', {
        //todo: doesn't work in nuxt checkout
        // no decoding, because it returns error when it cannot decode (Nuxt bug)
        // decode(value) {
        //     return value;
        // }
    });
    if (token.value) {
        headers['X-XSRF-TOKEN'] = token.value;
    }
    const { errors = true, loading = false, pricesLoading = false, headers: customHeaders, ...restOpts } = opts;

    navigationStore.setLoading(loading, pricesLoading);
    if (errors) {
        navigationStore.cleanErrors();
    }

    try {

        const res = await $fetch.raw('/api/client' + url, {
            headers: {
                ...headers,
                ...customHeaders,
            },
            ...restOpts,
        });

        //todo: this will never work anymore, different versions in cms and nuxt
        //cms doesnt now nuxt client version
        // //check version mismatch
        // if (process.env.NODE_ENV === 'production') {
        //     const serverVersion = res.headers.get('X-Version');
        //     const clientVersion = useRuntimeConfig().public.sentry.release;
        //     if (serverVersion && serverVersion !== clientVersion) {
        //         console.warn(`[Version Mismatch] Client: ${clientVersion}, Server: ${serverVersion}`);
        //         window.location.reload();
        //     }
        // }

        return await res._data;
    } catch (error) {
        if (errors) {
            if (error.response?.status === 401) {
                const localePath = useLocalePath();
                window.location.href = localePath({name: 'login'});
            } else if (error.response?.status === 422) {
                navigationStore.handleFormErrors(error.data.data.form_validation);
            } else if (error.response?.status === 400) {
                useAlertStore().error('global.something_went_wrong', error.response._data.message);
            } else {
                throw error;
            }
        } else {
            throw error;
        }
    } finally {
        navigationStore.setLoading(false);
    }
}
